import gql from 'graphql-tag';
import merge from 'lodash/merge';
import pickBy from 'lodash/pickBy';

import { createGqlQuery } from '../utils/apollo';

export const defaults = {
  hasFcLink: false,
  navianceInfo: {
    highSchoolNid: null,
    userId: null,
    __typename: 'NavianceInfo',
  },
};

export const queryNavianceInfo = gql`
  query {
    navianceInfo {
      ${createGqlQuery(defaults.navianceInfo)}
    }
  }
`;

export const resolvers = {
  Query: {},
  Mutation: {
    navianceInfo: (_, { navianceInfo: { ...rest }, override = true }, { cache }) => {
      const cacheData = cache.readQuery({ query: queryNavianceInfo });

      // validate navianceInfo input
      const navianceInfo = { ...rest };

      const data = override
        ? merge({}, cacheData, { navianceInfo })
        : merge({}, { navianceInfo }, { navianceInfo: pickBy(cacheData.navianceInfo) });

      cache.writeQuery({ query: queryNavianceInfo, data });
      return null;
    },
  },
};
